import { SVGProps } from "react";

const ToastSuccessIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" width="32" height="32" rx="16" fill="#00EC97" fillOpacity="0.08" />
      <path
        d="M10.5 16L14.7426 20.2426L23.227 11.7573"
        stroke="#00EC97"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 16L14.7426 20.2426L23.227 11.7573"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ToastSuccessIcon;
